// HBS i18n dictionary
// Default locale: ht (Kreyòl Ayisyen)
// Supported: ht, en, fr, es, pt

export const LANGUAGES = [
  { code: "ht", label: "Kreyòl", short: "HT", flag: "https://customer-assets.emergentagent.com/job_bonsevis-platform/artifacts/yybaez53_photo_8.jpg", flagType: "image" },
  { code: "en", label: "English", short: "EN", flag: "🇬🇧", flagType: "emoji" },
  { code: "fr", label: "Français", short: "FR", flag: "🇫🇷", flagType: "emoji" },
  { code: "es", label: "Español", short: "ES", flag: "🇪🇸", flagType: "emoji" },
  { code: "pt", label: "Português", short: "PT", flag: "🇵🇹", flagType: "emoji" },
];

export const DEFAULT_LOCALE = "ht";

export const TRANSLATIONS = {
  ht: {
    "nav.ledger": "Rejis la",
    "nav.missions": "Misyon",
    "nav.trading_posts": "Pòs Komèsyal",
    "nav.legacy": "Eritaj Nou",
    "nav.commission_btn": "Komisyone",
    "nav.commission_full": "Komisyone yon Chajman",

    "hero.tagline": "Libète ou Lanmò • 1804",
    "hero.title_1": "Estanda",
    "hero.title_italic": "Souvren",
    "hero.title_2": "pou Livrezon",
    "hero.title_3": "Global.",
    "hero.subtitle":
      "N ap konekte Dyaspora Ayisyen an ak kè peyi a an sekirite. Voye eritaj ou lakay ou avèk onè — depi nenpòt kote nan mond lan.",
    "hero.commission_btn": "› Komisyone yon Chajman",
    "hero.track_btn": "Gade Rejis la",
    "hero.stat_posts": "Pòs Komèsyal",
    "hero.stat_years": "Ane Onè",
    "hero.stat_manifests": "Manifès Sele",

    "ledger.eyebrow": "Rejis Wayal la",
    "ledger.title_1": "Gade",
    "ledger.title_italic": "Rejis la",
    "ledger.subtitle":
      "Vizibilite an tan reyèl atravè manifès diplomatik la. Antre nimewo swivi w pou konnen egzakteman lè chajman w lan rive nan pò a.",
    "ledger.placeholder": "Antre nimewo swivi a...",
    "ledger.submit_btn": "Konsilte Rejis la",
    "ledger.try_sample": "Eseye egzanp:",
    "ledger.error_unknown":
      "Manifès sa a enkoni pou Lapòs Wayal la. Tanpri verifye kalifikasyon w yo.",
    "ledger.manifest": "Manifès",
    "ledger.sender": "Voye pa",
    "ledger.receiver": "Resevwa pa",
    "ledger.cargo": "Chajman",
    "ledger.method": "Metòd",
    "ledger.journey": "Vwayaj la",
    "ledger.no_milestones": "Poko gen okenn etap anrejistre.",

    "missions.eyebrow": "Misyon Nou",
    "missions.title_1": "Twa pilye,",
    "missions.title_2": "yon estanda",
    "missions.title_italic": "souvren.",
    "missions.subtitle":
      "Chak manifès Hayti Bon Sèvis Shipping sele ak entegrite yon dispatch diplomatik — depi moman chajman ou komisyone nan pòs nou yo, jiskaske li mete nan men moun ou renmen yo.",
    "missions.pillar1_title": "Lapòs Wayal",
    "missions.pillar1_text":
      "Frè ayè ak lanmè ki fyab pou efè pèsonèl, baril, ak machandiz komèsyal.",
    "missions.pillar2_title": "Swivi Diplomatik",
    "missions.pillar2_text":
      'Vizibilite an tan reyèl atravè "Rejis la." Konnen egzakteman lè chajman w rive nan pò a.',
    "missions.pillar3_title": "Rezo Global",
    "missions.pillar3_text":
      "Sant estratejik nan Miami, Montréal, Santiago, ak Pòtoprens.",
    "missions.pillar": "Pilye",

    "posts.eyebrow": "Rezo a",
    "posts.title_1": "Pòs",
    "posts.title_italic": "Komèsyal",
    "posts.subtitle": "Tèminal estratejik soti dyaspora a pou rive nan peyi an.",
    "posts.label": "Pòs No",

    "calc.eyebrow": "Estimasyon an",
    "calc.title_1": "Estime",
    "calc.title_italic": "komisyon",
    "calc.title_2": "ou.",
    "calc.subtitle":
      "To transparen kalkile pa kalite manifès ak pwa. Lapòs Wayal onore yon fre jis.",
    "calc.method": "Metòd",
    "calc.cargo_type": "Tip Chajman",
    "calc.weight": "Pwa (lbs)",
    "calc.volume": "Volim (cu.ft)",
    "calc.submit_btn": "Estime Fre a",
    "calc.result_label": "Fre Estime",

    "legacy.eyebrow": "Eritaj Nou",
    "legacy.title_1": "Depi",
    "legacy.title_italic": "1804",
    "legacy.title_2": "jis jodi a — yon onè konfye.",
    "legacy.body":
      "Hayti Bon Sèvis Shipping pote lespri premye repiblik nwa souvren nan mond lan. Chak chajman pi plis pase yon kago — se yon angajman ant dyaspora a ak fanmi nan peyi a. Nou trete baril tankou dokiman leta epi ti pakèt tankou so leta.",
    "legacy.value1_k": "Libète",
    "legacy.value1_v": "Libète chwa nan chak wout.",
    "legacy.value2_k": "Onè",
    "legacy.value2_v": "Onè nan chak transfè.",
    "legacy.value3_k": "Inyon",
    "legacy.value3_v": "Dyaspora ak peyi natal, yon sèl bondaj.",
    "legacy.motto_caption": "— Deviz Souvren an",

    "footer.motto_caption": "Sèvi Kominote Ayisyen an Atravè Mond lan.",
    "footer.tag":
      "N ap konekte dyaspora a ak kè peyi a an sekirite.",
    "footer.col_order": "Lòd la",
    "footer.col_posts": "Pòs Komèsyal",
    "footer.copyright": "© 2026 Hayti Bon Sèvis Shipping. Tout dwa rezève.",
    "footer.support": "Sekretarya Royal la",

    "commission.eyebrow": "Komisyonman an",
    "commission.title_1": "Komisyone yon",
    "commission.title_italic": "Chajman",
    "commission.subtitle":
      "Sele manifès ou. Apre soumèt, w ap resevwa yon nimewo swivi souvren pou konsilte Rejis la nenpòt lè.",
    "commission.section_sender": "Voye (Dyaspora)",
    "commission.section_receiver": "Resevwa (Peyi Natal)",
    "commission.section_manifest": "Manifès la",
    "commission.fullname": "Non konplè",
    "commission.email": "Imèl",
    "commission.phone": "Telefòn",
    "commission.lang_pref": "Lang Prefere",
    "commission.origin": "Pòs Orijin",
    "commission.destination": "Destinasyon",
    "commission.cargo": "Tip Chajman",
    "commission.method": "Metòd",
    "commission.weight": "Pwa (lbs, opsyonèl)",
    "commission.cancel": "Anile",
    "commission.submit": "Sele Manifès la",
    "commission.note":
      "Yon fwa soumèt, manifès sa a sele anba Lapòs Wayal la.",
    "commission.success_eyebrow": "Manifès Sele",
    "commission.success_title_1": "Chajman ou",
    "commission.success_title_italic": "komisyone.",
    "commission.tracking_label": "Nimewo Swivi",
    "commission.estimated_toll": "Fre estime:",
    "commission.goto_track": "Gade Rejis la",
    "commission.return_home": "Retounen lakay",

    "common.copy": "Kopye",
    "common.copied": "Kopye!",
    "common.loading": "Ap konsilte Rejis la...",

    "page.title": "Hayti Bon Sèvis Shipping — Seli l ye",

    "status.Commissioned": "Chajman Komisyone",
    "status.At Warehouse": "Nan Depo",
    "status.In Transit": "Sou Wout",
    "status.In Transit.Sea Freight": "Sou Lanmè",
    "status.In Transit.Air Freight": "Nan Syèl",
    "status.At Customs": "Nan Ladwann",
    "status.Ready for Pickup": "Pare pou Rekiperasyon",
    "status.Delivered": "Misyon Akonpli",
    "status.At Port": "Pare pou Rekiperasyon",
  },

  en: {
    "nav.ledger": "The Ledger",
    "nav.missions": "Missions",
    "nav.trading_posts": "Trading Posts",
    "nav.legacy": "Our Legacy",
    "nav.commission_btn": "Commission",
    "nav.commission_full": "Commission a Shipment",

    "hero.tagline": "Liberté ou la Mort • 1804",
    "hero.title_1": "The",
    "hero.title_italic": "Sovereign",
    "hero.title_2": "Standard of Global",
    "hero.title_3": "Delivery.",
    "hero.subtitle":
      "Securely connecting the Haitian Diaspora to the heart of the nation. Sending your legacy home with honor — from anywhere in the world.",
    "hero.commission_btn": "› Commission a Shipment",
    "hero.track_btn": "View the Ledger",
    "hero.stat_posts": "Trading Posts",
    "hero.stat_years": "Years of Honor",
    "hero.stat_manifests": "Manifests Sealed",

    "ledger.eyebrow": "The Royal Ledger",
    "ledger.title_1": "View the",
    "ledger.title_italic": "Ledger",
    "ledger.subtitle":
      "Real-time visibility through the diplomatic manifest. Enter your waybill to know exactly when your cargo reaches the port.",
    "ledger.placeholder": "Enter tracking number...",
    "ledger.submit_btn": "Verify Manifest",
    "ledger.try_sample": "Try sample:",
    "ledger.error_unknown":
      "This manifest is unknown to the Royal Post. Please check your credentials.",
    "ledger.manifest": "Manifest",
    "ledger.sender": "Sender",
    "ledger.receiver": "Receiver",
    "ledger.cargo": "Cargo",
    "ledger.method": "Method",
    "ledger.journey": "The Journey",
    "ledger.no_milestones": "No milestones recorded yet.",

    "missions.eyebrow": "Our Missions",
    "missions.title_1": "Three pillars,",
    "missions.title_2": "one",
    "missions.title_italic": "sovereign standard.",
    "missions.subtitle":
      "Every Hayti Bon Sèvis Shipping manifest is sealed with the integrity of a diplomatic dispatch — from the moment your cargo is commissioned at our trading posts, until it is placed in the hands of your loved ones.",
    "missions.pillar1_title": "The Royal Post",
    "missions.pillar1_text":
      "Reliable air and sea freight for personal effects, barrels, and commercial merchandise.",
    "missions.pillar2_title": "Diplomatic Tracking",
    "missions.pillar2_text":
      'Real-time visibility through "The Ledger." Know exactly when your cargo reaches the port.',
    "missions.pillar3_title": "Global Network",
    "missions.pillar3_text":
      "Strategic hubs in Miami, Montréal, Santiago, and Port-au-Prince.",
    "missions.pillar": "Pillar",

    "posts.eyebrow": "The Network",
    "posts.title_1": "Trading",
    "posts.title_italic": "Posts",
    "posts.subtitle": "Strategic terminals from the diaspora to the homeland.",
    "posts.label": "Post N°",

    "calc.eyebrow": "The Appraisal",
    "calc.title_1": "Estimate your",
    "calc.title_italic": "commission",
    "calc.title_2": ".",
    "calc.subtitle":
      "Transparent rates calculated by manifest type and weight. The Royal Post honors a fair toll.",
    "calc.method": "Method",
    "calc.cargo_type": "Cargo Type",
    "calc.weight": "Weight (lbs)",
    "calc.volume": "Volume (cu.ft)",
    "calc.submit_btn": "Appraise the Toll",
    "calc.result_label": "Estimated Toll",

    "legacy.eyebrow": "Our Legacy",
    "legacy.title_1": "From",
    "legacy.title_italic": "1804",
    "legacy.title_2": "to today — an honor entrusted.",
    "legacy.body":
      "Hayti Bon Sèvis Shipping carries forward the spirit of the world's first sovereign Black republic. Every shipment is more than cargo — it is a vow between the diaspora abroad and the family at home. We treat barrels like state documents and small parcels like state seals.",
    "legacy.value1_k": "Liberté",
    "legacy.value1_v": "Freedom of choice in every route.",
    "legacy.value2_k": "Honneur",
    "legacy.value2_v": "Honor in every handoff.",
    "legacy.value3_k": "Union",
    "legacy.value3_v": "Diaspora and homeland, one bond.",
    "legacy.motto_caption": "— The Sovereign Motto",

    "footer.motto_caption": "Serving the Haitian Community Worldwide.",
    "footer.tag":
      "Securely connecting the diaspora to the heart of the nation.",
    "footer.col_order": "The Order",
    "footer.col_posts": "Trading Posts",
    "footer.copyright": "© 2026 Hayti Bon Sèvis Shipping. All Rights Reserved.",
    "footer.support": "The Royal Secretary",

    "commission.eyebrow": "The Commissioning",
    "commission.title_1": "Commission a",
    "commission.title_italic": "Shipment",
    "commission.subtitle":
      "Seal your manifest. Once submitted, you will receive a sovereign tracking number to consult the Ledger at any moment.",
    "commission.section_sender": "Sender (Diaspora)",
    "commission.section_receiver": "Receiver (Homeland)",
    "commission.section_manifest": "The Manifest",
    "commission.fullname": "Full name",
    "commission.email": "Email",
    "commission.phone": "Phone",
    "commission.lang_pref": "Preferred Language",
    "commission.origin": "Origin Trading Post",
    "commission.destination": "Destination",
    "commission.cargo": "Cargo Type",
    "commission.method": "Method",
    "commission.weight": "Weight (lbs, optional)",
    "commission.cancel": "Cancel",
    "commission.submit": "Seal the Manifest",
    "commission.note":
      "Once submitted, this manifest is sealed under the Royal Post.",
    "commission.success_eyebrow": "Manifest Sealed",
    "commission.success_title_1": "Your shipment is",
    "commission.success_title_italic": "commissioned.",
    "commission.tracking_label": "Tracking ID",
    "commission.estimated_toll": "Estimated toll:",
    "commission.goto_track": "View the Ledger",
    "commission.return_home": "Return Home",

    "common.copy": "Copy",
    "common.copied": "Copied!",
    "common.loading": "Verifying manifest...",

    "page.title": "Hayti Bon Sèvis Shipping — The Sovereign Standard",

    "status.Commissioned": "Commissioned",
    "status.At Warehouse": "At Warehouse",
    "status.In Transit": "In Transit",
    "status.In Transit.Sea Freight": "In Transit (Sea)",
    "status.In Transit.Air Freight": "In Transit (Air)",
    "status.At Customs": "At Customs",
    "status.Ready for Pickup": "Ready for Pickup",
    "status.Delivered": "Delivered",
    "status.At Port": "Ready for Pickup",
  },

  fr: {
    "nav.ledger": "Le Registre",
    "nav.missions": "Missions",
    "nav.trading_posts": "Comptoirs",
    "nav.legacy": "Notre Héritage",
    "nav.commission_btn": "Commissionner",
    "nav.commission_full": "Commissionner une Expédition",

    "hero.tagline": "Liberté ou la Mort • 1804",
    "hero.title_1": "L'Étendard",
    "hero.title_italic": "Souverain",
    "hero.title_2": "de la Livraison",
    "hero.title_3": "Globale.",
    "hero.subtitle":
      "Connecter en toute sécurité la Diaspora Haïtienne au cœur de la nation. Envoyer votre héritage chez vous avec honneur — depuis n'importe où dans le monde.",
    "hero.commission_btn": "› Commissionner une Expédition",
    "hero.track_btn": "Consulter le Registre",
    "hero.stat_posts": "Comptoirs",
    "hero.stat_years": "Ans d'Honneur",
    "hero.stat_manifests": "Manifestes Scellés",

    "ledger.eyebrow": "Le Registre Royal",
    "ledger.title_1": "Consulter le",
    "ledger.title_italic": "Registre",
    "ledger.subtitle":
      "Visibilité en temps réel à travers le manifeste diplomatique. Entrez votre numéro pour savoir exactement quand votre cargaison arrive au port.",
    "ledger.placeholder": "Entrez le numéro de suivi...",
    "ledger.submit_btn": "Vérifier le Manifeste",
    "ledger.try_sample": "Essayez:",
    "ledger.error_unknown":
      "Ce manifeste est inconnu de la Poste Royale. Veuillez vérifier vos références.",
    "ledger.manifest": "Manifeste",
    "ledger.sender": "Expéditeur",
    "ledger.receiver": "Destinataire",
    "ledger.cargo": "Cargaison",
    "ledger.method": "Méthode",
    "ledger.journey": "Le Voyage",
    "ledger.no_milestones": "Aucun jalon enregistré pour le moment.",

    "missions.eyebrow": "Nos Missions",
    "missions.title_1": "Trois piliers,",
    "missions.title_2": "un seul étendard",
    "missions.title_italic": "souverain.",
    "missions.subtitle":
      "Chaque manifeste Hayti Bon Sèvis Shipping est scellé avec l'intégrité d'une dépêche diplomatique — du moment où votre cargaison est commissionnée à nos comptoirs, jusqu'à sa remise entre les mains de vos proches.",
    "missions.pillar1_title": "La Poste Royale",
    "missions.pillar1_text":
      "Fret aérien et maritime fiable pour effets personnels, barils et marchandises commerciales.",
    "missions.pillar2_title": "Suivi Diplomatique",
    "missions.pillar2_text":
      'Visibilité en temps réel via "Le Registre." Sachez exactement quand votre cargaison atteint le port.',
    "missions.pillar3_title": "Réseau Global",
    "missions.pillar3_text":
      "Hubs stratégiques à Miami, Montréal, Santiago et Port-au-Prince.",
    "missions.pillar": "Pilier",

    "posts.eyebrow": "Le Réseau",
    "posts.title_1": "Les",
    "posts.title_italic": "Comptoirs",
    "posts.subtitle": "Terminaux stratégiques de la diaspora à la patrie.",
    "posts.label": "Comptoir N°",

    "calc.eyebrow": "L'Évaluation",
    "calc.title_1": "Estimez votre",
    "calc.title_italic": "commission",
    "calc.title_2": ".",
    "calc.subtitle":
      "Tarifs transparents calculés selon le type de manifeste et le poids. La Poste Royale honore un péage juste.",
    "calc.method": "Méthode",
    "calc.cargo_type": "Type de Cargaison",
    "calc.weight": "Poids (lbs)",
    "calc.volume": "Volume (pi³)",
    "calc.submit_btn": "Évaluer le Péage",
    "calc.result_label": "Péage Estimé",

    "legacy.eyebrow": "Notre Héritage",
    "legacy.title_1": "De",
    "legacy.title_italic": "1804",
    "legacy.title_2": "à aujourd'hui — un honneur confié.",
    "legacy.body":
      "Hayti Bon Sèvis Shipping perpétue l'esprit de la première république noire souveraine du monde. Chaque expédition est plus qu'une cargaison — c'est un vœu entre la diaspora à l'étranger et la famille au pays. Nous traitons les barils comme des documents d'État et les petits colis comme des sceaux d'État.",
    "legacy.value1_k": "Liberté",
    "legacy.value1_v": "Liberté de choix sur chaque route.",
    "legacy.value2_k": "Honneur",
    "legacy.value2_v": "Honneur à chaque transmission.",
    "legacy.value3_k": "Union",
    "legacy.value3_v": "Diaspora et patrie, un seul lien.",
    "legacy.motto_caption": "— La Devise Souveraine",

    "footer.motto_caption": "Au Service de la Communauté Haïtienne dans le Monde.",
    "footer.tag":
      "Connecter en toute sécurité la diaspora au cœur de la nation.",
    "footer.col_order": "L'Ordre",
    "footer.col_posts": "Comptoirs",
    "footer.copyright": "© 2026 Hayti Bon Sèvis Shipping. Tous droits réservés.",
    "footer.support": "Le Secrétariat Royal",

    "commission.eyebrow": "Le Commissionnement",
    "commission.title_1": "Commissionner une",
    "commission.title_italic": "Expédition",
    "commission.subtitle":
      "Scellez votre manifeste. Une fois soumis, vous recevrez un numéro de suivi souverain pour consulter le Registre à tout moment.",
    "commission.section_sender": "Expéditeur (Diaspora)",
    "commission.section_receiver": "Destinataire (Patrie)",
    "commission.section_manifest": "Le Manifeste",
    "commission.fullname": "Nom complet",
    "commission.email": "Email",
    "commission.phone": "Téléphone",
    "commission.lang_pref": "Langue préférée",
    "commission.origin": "Comptoir d'origine",
    "commission.destination": "Destination",
    "commission.cargo": "Type de Cargaison",
    "commission.method": "Méthode",
    "commission.weight": "Poids (lbs, optionnel)",
    "commission.cancel": "Annuler",
    "commission.submit": "Sceller le Manifeste",
    "commission.note":
      "Une fois soumis, ce manifeste est scellé sous la Poste Royale.",
    "commission.success_eyebrow": "Manifeste Scellé",
    "commission.success_title_1": "Votre expédition est",
    "commission.success_title_italic": "commissionnée.",
    "commission.tracking_label": "Numéro de Suivi",
    "commission.estimated_toll": "Péage estimé:",
    "commission.goto_track": "Consulter le Registre",
    "commission.return_home": "Retour à l'accueil",

    "common.copy": "Copier",
    "common.copied": "Copié!",
    "common.loading": "Consultation du Registre...",
  },

  es: {
    "nav.ledger": "El Registro",
    "nav.missions": "Misiones",
    "nav.trading_posts": "Puestos",
    "nav.legacy": "Nuestro Legado",
    "nav.commission_btn": "Comisionar",
    "nav.commission_full": "Comisionar un Envío",

    "hero.tagline": "Liberté ou la Mort • 1804",
    "hero.title_1": "El Estándar",
    "hero.title_italic": "Soberano",
    "hero.title_2": "de Entrega",
    "hero.title_3": "Global.",
    "hero.subtitle":
      "Conectando con seguridad a la Diáspora Haitiana con el corazón de la nación. Envíe su legado a casa con honor — desde cualquier lugar del mundo.",
    "hero.commission_btn": "› Comisionar un Envío",
    "hero.track_btn": "Ver el Registro",
    "hero.stat_posts": "Puestos",
    "hero.stat_years": "Años de Honor",
    "hero.stat_manifests": "Manifiestos Sellados",

    "ledger.eyebrow": "El Registro Real",
    "ledger.title_1": "Ver el",
    "ledger.title_italic": "Registro",
    "ledger.subtitle":
      "Visibilidad en tiempo real a través del manifiesto diplomático. Ingrese su guía para saber exactamente cuándo llega su carga al puerto.",
    "ledger.placeholder": "Ingrese el número de guía...",
    "ledger.submit_btn": "Verificar Manifiesto",
    "ledger.try_sample": "Pruebe:",
    "ledger.error_unknown":
      "Este manifiesto es desconocido para el Correo Real. Por favor verifique sus credenciales.",
    "ledger.manifest": "Manifiesto",
    "ledger.sender": "Remitente",
    "ledger.receiver": "Destinatario",
    "ledger.cargo": "Carga",
    "ledger.method": "Método",
    "ledger.journey": "El Viaje",
    "ledger.no_milestones": "Aún no hay hitos registrados.",

    "missions.eyebrow": "Nuestras Misiones",
    "missions.title_1": "Tres pilares,",
    "missions.title_2": "un estándar",
    "missions.title_italic": "soberano.",
    "missions.subtitle":
      "Cada manifiesto Hayti Bon Sèvis Shipping está sellado con la integridad de un despacho diplomático — desde el momento en que su carga es comisionada en nuestros puestos, hasta entregarse en manos de sus seres queridos.",
    "missions.pillar1_title": "El Correo Real",
    "missions.pillar1_text":
      "Flete aéreo y marítimo confiable para efectos personales, barriles y mercancías comerciales.",
    "missions.pillar2_title": "Seguimiento Diplomático",
    "missions.pillar2_text":
      'Visibilidad en tiempo real a través de "El Registro." Sepa exactamente cuándo llega su carga al puerto.',
    "missions.pillar3_title": "Red Global",
    "missions.pillar3_text":
      "Centros estratégicos en Miami, Montreal, Santiago y Puerto Príncipe.",
    "missions.pillar": "Pilar",

    "posts.eyebrow": "La Red",
    "posts.title_1": "Puestos",
    "posts.title_italic": "Comerciales",
    "posts.subtitle": "Terminales estratégicas de la diáspora a la patria.",
    "posts.label": "Puesto N°",

    "calc.eyebrow": "La Tasación",
    "calc.title_1": "Estime su",
    "calc.title_italic": "comisión",
    "calc.title_2": ".",
    "calc.subtitle":
      "Tarifas transparentes calculadas por tipo de manifiesto y peso. El Correo Real honra un peaje justo.",
    "calc.method": "Método",
    "calc.cargo_type": "Tipo de Carga",
    "calc.weight": "Peso (lbs)",
    "calc.volume": "Volumen (pies³)",
    "calc.submit_btn": "Tasar el Peaje",
    "calc.result_label": "Peaje Estimado",

    "legacy.eyebrow": "Nuestro Legado",
    "legacy.title_1": "Desde",
    "legacy.title_italic": "1804",
    "legacy.title_2": "hasta hoy — un honor confiado.",
    "legacy.body":
      "Hayti Bon Sèvis Shipping lleva el espíritu de la primera república negra soberana del mundo. Cada envío es más que carga — es un voto entre la diáspora en el extranjero y la familia en casa. Tratamos los barriles como documentos de estado y los pequeños paquetes como sellos de estado.",
    "legacy.value1_k": "Libertad",
    "legacy.value1_v": "Libertad de elección en cada ruta.",
    "legacy.value2_k": "Honor",
    "legacy.value2_v": "Honor en cada entrega.",
    "legacy.value3_k": "Unión",
    "legacy.value3_v": "Diáspora y patria, un solo lazo.",
    "legacy.motto_caption": "— El Lema Soberano",

    "footer.motto_caption": "Sirviendo a la Comunidad Haitiana en Todo el Mundo.",
    "footer.tag":
      "Conectando con seguridad la diáspora con el corazón de la nación.",
    "footer.col_order": "La Orden",
    "footer.col_posts": "Puestos Comerciales",
    "footer.copyright": "© 2026 Hayti Bon Sèvis Shipping. Todos los derechos reservados.",
    "footer.support": "La Secretaría Real",

    "commission.eyebrow": "La Comisión",
    "commission.title_1": "Comisionar un",
    "commission.title_italic": "Envío",
    "commission.subtitle":
      "Selle su manifiesto. Una vez enviado, recibirá un número de seguimiento soberano para consultar el Registro en cualquier momento.",
    "commission.section_sender": "Remitente (Diáspora)",
    "commission.section_receiver": "Destinatario (Patria)",
    "commission.section_manifest": "El Manifiesto",
    "commission.fullname": "Nombre completo",
    "commission.email": "Correo",
    "commission.phone": "Teléfono",
    "commission.lang_pref": "Idioma preferido",
    "commission.origin": "Puesto de origen",
    "commission.destination": "Destino",
    "commission.cargo": "Tipo de Carga",
    "commission.method": "Método",
    "commission.weight": "Peso (lbs, opcional)",
    "commission.cancel": "Cancelar",
    "commission.submit": "Sellar el Manifiesto",
    "commission.note":
      "Una vez enviado, este manifiesto está sellado bajo el Correo Real.",
    "commission.success_eyebrow": "Manifiesto Sellado",
    "commission.success_title_1": "Su envío está",
    "commission.success_title_italic": "comisionado.",
    "commission.tracking_label": "Número de Seguimiento",
    "commission.estimated_toll": "Peaje estimado:",
    "commission.goto_track": "Ver el Registro",
    "commission.return_home": "Volver al inicio",

    "common.copy": "Copiar",
    "common.copied": "¡Copiado!",
    "common.loading": "Verificando manifiesto...",

    "page.title": "Hayti Bon Sèvis Shipping — El Estándar Soberano",

    "status.Commissioned": "Comisionado",
    "status.At Warehouse": "En Depósito",
    "status.In Transit": "En Tránsito",
    "status.In Transit.Sea Freight": "Por Mar",
    "status.In Transit.Air Freight": "Por Aire",
    "status.At Customs": "En Aduana",
    "status.Ready for Pickup": "Listo para Retirar",
    "status.Delivered": "Misión Cumplida",
    "status.At Port": "Listo para Retirar",
  },

  pt: {
    "nav.ledger": "O Registro",
    "nav.missions": "Missões",
    "nav.trading_posts": "Postos",
    "nav.legacy": "Nosso Legado",
    "nav.commission_btn": "Comissionar",
    "nav.commission_full": "Comissionar um Envio",

    "hero.tagline": "Liberté ou la Mort • 1804",
    "hero.title_1": "O Padrão",
    "hero.title_italic": "Soberano",
    "hero.title_2": "de Entrega",
    "hero.title_3": "Global.",
    "hero.subtitle":
      "Conectando com segurança a Diáspora Haitiana ao coração da nação. Enviando seu legado para casa com honra — de qualquer lugar do mundo.",
    "hero.commission_btn": "› Comissionar um Envio",
    "hero.track_btn": "Ver o Registro",
    "hero.stat_posts": "Postos",
    "hero.stat_years": "Anos de Honra",
    "hero.stat_manifests": "Manifestos Selados",

    "ledger.eyebrow": "O Registro Real",
    "ledger.title_1": "Ver o",
    "ledger.title_italic": "Registro",
    "ledger.subtitle":
      "Visibilidade em tempo real através do manifesto diplomático. Insira seu número para saber exatamente quando sua carga chega ao porto.",
    "ledger.placeholder": "Insira o número de rastreio...",
    "ledger.submit_btn": "Verificar Manifesto",
    "ledger.try_sample": "Experimente:",
    "ledger.error_unknown":
      "Este manifesto é desconhecido para o Correio Real. Por favor verifique suas credenciais.",
    "ledger.manifest": "Manifesto",
    "ledger.sender": "Remetente",
    "ledger.receiver": "Destinatário",
    "ledger.cargo": "Carga",
    "ledger.method": "Método",
    "ledger.journey": "A Jornada",
    "ledger.no_milestones": "Nenhum marco registrado ainda.",

    "missions.eyebrow": "Nossas Missões",
    "missions.title_1": "Três pilares,",
    "missions.title_2": "um padrão",
    "missions.title_italic": "soberano.",
    "missions.subtitle":
      "Cada manifesto Hayti Bon Sèvis Shipping é selado com a integridade de um despacho diplomático — desde o momento em que sua carga é comissionada em nossos postos, até ser entregue nas mãos de seus entes queridos.",
    "missions.pillar1_title": "O Correio Real",
    "missions.pillar1_text":
      "Frete aéreo e marítimo confiável para pertences pessoais, barris e mercadorias comerciais.",
    "missions.pillar2_title": "Rastreamento Diplomático",
    "missions.pillar2_text":
      'Visibilidade em tempo real através de "O Registro." Saiba exatamente quando sua carga chega ao porto.',
    "missions.pillar3_title": "Rede Global",
    "missions.pillar3_text":
      "Hubs estratégicos em Miami, Montreal, Santiago e Porto Príncipe.",
    "missions.pillar": "Pilar",

    "posts.eyebrow": "A Rede",
    "posts.title_1": "Postos",
    "posts.title_italic": "Comerciais",
    "posts.subtitle": "Terminais estratégicos da diáspora à pátria.",
    "posts.label": "Posto N°",

    "calc.eyebrow": "A Avaliação",
    "calc.title_1": "Estime sua",
    "calc.title_italic": "comissão",
    "calc.title_2": ".",
    "calc.subtitle":
      "Taxas transparentes calculadas por tipo de manifesto e peso. O Correio Real honra um pedágio justo.",
    "calc.method": "Método",
    "calc.cargo_type": "Tipo de Carga",
    "calc.weight": "Peso (lbs)",
    "calc.volume": "Volume (pés³)",
    "calc.submit_btn": "Avaliar o Pedágio",
    "calc.result_label": "Pedágio Estimado",

    "legacy.eyebrow": "Nosso Legado",
    "legacy.title_1": "De",
    "legacy.title_italic": "1804",
    "legacy.title_2": "até hoje — uma honra confiada.",
    "legacy.body":
      "Hayti Bon Sèvis Shipping carrega o espírito da primeira república negra soberana do mundo. Cada envio é mais do que carga — é um voto entre a diáspora no exterior e a família em casa. Tratamos barris como documentos de estado e pequenas encomendas como selos de estado.",
    "legacy.value1_k": "Liberdade",
    "legacy.value1_v": "Liberdade de escolha em cada rota.",
    "legacy.value2_k": "Honra",
    "legacy.value2_v": "Honra em cada entrega.",
    "legacy.value3_k": "União",
    "legacy.value3_v": "Diáspora e pátria, um só laço.",
    "legacy.motto_caption": "— O Lema Soberano",

    "footer.motto_caption": "Servindo a Comunidade Haitiana em Todo o Mundo.",
    "footer.tag":
      "Conectando com segurança a diáspora ao coração da nação.",
    "footer.col_order": "A Ordem",
    "footer.col_posts": "Postos Comerciais",
    "footer.copyright": "© 2026 Hayti Bon Sèvis Shipping. Todos os direitos reservados.",
    "footer.support": "A Secretaria Real",

    "commission.eyebrow": "A Comissão",
    "commission.title_1": "Comissionar um",
    "commission.title_italic": "Envio",
    "commission.subtitle":
      "Sele seu manifesto. Uma vez enviado, você receberá um número de rastreamento soberano para consultar o Registro a qualquer momento.",
    "commission.section_sender": "Remetente (Diáspora)",
    "commission.section_receiver": "Destinatário (Pátria)",
    "commission.section_manifest": "O Manifesto",
    "commission.fullname": "Nome completo",
    "commission.email": "Email",
    "commission.phone": "Telefone",
    "commission.lang_pref": "Idioma preferido",
    "commission.origin": "Posto de origem",
    "commission.destination": "Destino",
    "commission.cargo": "Tipo de Carga",
    "commission.method": "Método",
    "commission.weight": "Peso (lbs, opcional)",
    "commission.cancel": "Cancelar",
    "commission.submit": "Selar o Manifesto",
    "commission.note":
      "Uma vez enviado, este manifesto é selado sob o Correio Real.",
    "commission.success_eyebrow": "Manifesto Selado",
    "commission.success_title_1": "Seu envio está",
    "commission.success_title_italic": "comissionado.",
    "commission.tracking_label": "Número de Rastreamento",
    "commission.estimated_toll": "Pedágio estimado:",
    "commission.goto_track": "Ver o Registro",
    "commission.return_home": "Voltar ao início",

    "common.copy": "Copiar",
    "common.copied": "Copiado!",
    "common.loading": "Verificando manifesto...",

    "page.title": "Hayti Bon Sèvis Shipping — O Padrão Soberano",

    "status.Commissioned": "Comissionado",
    "status.At Warehouse": "No Depósito",
    "status.In Transit": "Em Trânsito",
    "status.In Transit.Sea Freight": "Pelo Mar",
    "status.In Transit.Air Freight": "Pelos Ares",
    "status.At Customs": "Na Alfândega",
    "status.Ready for Pickup": "Pronto para Retirada",
    "status.Delivered": "Missão Cumprida",
    "status.At Port": "Pronto para Retirada",
  },
};
